export default `
-- AlterTable
ALTER TABLE "User" ADD COLUMN "profile_picture_file_id" TEXT;

-- CreateIndex
CREATE INDEX "User_profile_picture_file_id_idx" ON "User"("profile_picture_file_id");
`;
